<template>
	<div class="stylePreview" v-if="buttonStyle">
		<div :class="isExpand ? 'warp active' : 'warp'">
			<div class="contactIcons">
				<div v-for="(item, index) in icon_list" :key="index">
					<el-tooltip placement="left" :content="item.textInfo" :disabled="!item.textInfo">
						<a class="sidebox" :style="buttonStyle.expandFlag ? `transitionDelay:  200ms` : ''">
							<i
								class="sideicon"
								:style="
									buttonStyle.colourType == 1 ? '' : `background-color:  ${buttonStyle.colour}`
								"
								v-html="item.iconLink"
							></i>
						</a>
					</el-tooltip>
				</div>
			</div>

			<el-tooltip
				:content="buttonStyle.floatingTips"
				:disabled="!buttonStyle.floatingTips || isExpand"
				placement="left"
			>
				<el-tooltip
					:value="showTips"
					:manual="true"
					:content="buttonStyle.bootTips"
					placement="left"
				>
					<button
						class="buttonWarp"
						:style="buttonStyle.colourType == 1 ? '' : `background-color:  ${buttonStyle.colour}`"
						@click="buttonClick"
						@mouseenter="butMouseenter"
					>
						<i class="closeIcon" v-html="buttonStyle.closeLink" alt="" />
						<i class="messageIcon" v-html="buttonStyle.expandLink" alt="" />
					</button>
				</el-tooltip>
			</el-tooltip>
		</div>
	</div>
</template>

<script>
export default {
	name: 'stylePreview',
	props: ['configInfo'],
	data() {
		return {
			icon_list: [],
			buttonStyle: null,
			isExpand: false,
			showTips: false,
			time: null,
		};
	},
	watch: {
		configInfo: {
			handler(val) {
				this.init(val);
			},
			deep: true,
		},
	},
	methods: {
		// 初始化
		init(data) {
			let { fbConfigChannelVOList, fbConfigPluginsVO } = data;
			this.icon_list = fbConfigChannelVOList?.filter(item => item.openFlag);
			this.buttonStyle = fbConfigPluginsVO;
			this.isExpand = fbConfigPluginsVO?.expandFlag ? true : false;
			this.showTips = false;

			if (this.time) {
				clearTimeout(this.time);
			}

			this.isShowTips();
		},
		//图标点击
		buttonClick() {
			this.isExpand = !this.isExpand;
		},
		// 判断是否显示引导点击提示文本
		isShowTips() {
			let { isExpand, buttonStyle } = this;
			let { bootTips } = buttonStyle || {};

			if (!bootTips) return;

			if (!isExpand && !!bootTips) {
				this.time = setTimeout(() => {
					this.showTips = true;
				}, 5000);
			}
		},
		butMouseenter() {
			this.showTips = false;
			if (this.time) {
				clearTimeout(this.time);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.stylePreview {
	width: 50px;
	transform-origin: calc(100% + 40px) calc(100% + 40px);
	position: fixed;
	bottom: 150px;
	right: 100px;
	z-index: 9999;

	::v-deep svg {
		height: 100%;
		width: 100%;
	}

	.warp {
		position: relative;
		transition: bottom 0.4s ease;

		.contactIcons {
			.sidebox {
				align-items: center;
				display: inline-flex;
				justify-content: center;
				opacity: 0;
				position: relative;
				transform: scale(0);
				transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0ms, opacity 0.8s;
				margin-bottom: 10px;

				.sideicon {
					background: rgb(70, 177, 234);
					transition: all 480ms ease 0s;
					border-radius: 50%;
					height: 50px;
					width: 50px;
					padding: 0;
					overflow: hidden;
					border: 0;
					cursor: pointer;
					outline: none;
					display: flex;
					align-items: center;
					justify-content: center;

					svg {
						color: #fff;
						height: 50px;
						width: 50px;
					}
				}

				.hoverText {
					margin: 0 calc(100% + 10px);
					left: auto;
					right: 0;
					width: max-content;
					background-color: #464646;
					border-radius: 5px;
					color: #fff;
					display: none;
					font-family: Arial, Helvetica, sans-serif;
					font-size: 11px;
					padding: 5px;
					position: absolute;
					white-space: nowrap;
				}
			}

			.sidebox:hover {
				.hoverText {
					display: block;
				}
			}
		}

		.buttonWarp {
			position: relative;
			height: 50px;
			width: 50px;
			padding: 0;
			background-color: rgb(70, 177, 234);
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.1s ease-in-out;
			border: 0;
			cursor: pointer;
			outline: none;

			.messageIcon {
				visibility: visible;
				transition: all 1ms;
				transition-delay: 0.1s;
				line-height: 0;
				overflow: hidden;

				svg {
					color: #fff;
				}
			}

			.closeIcon {
				position: absolute;
				transform: rotate(120deg);
				transition: all 0.2s ease-in-out;
				visibility: hidden;
				opacity: 0;

				svg {
					color: #fff;
				}
			}

			.hoverInfo {
				margin: 0 calc(100% + 10px);
				left: auto;
				right: 0;
				width: max-content;
				background-color: #464646;
				border-radius: 5px;
				color: #fff;
				display: none;
				font-family: Arial, Helvetica, sans-serif;
				font-size: 11px;
				padding: 5px;
				position: absolute;
				white-space: nowrap;
			}
		}

		.buttonWarp:hover .hoverInfo {
			display: block;
		}
	}

	.warp.active {
		.contactIcons {
			.sidebox {
				opacity: 1;
				transform: scale(1);
			}
		}

		.buttonWarp {
			.closeIcon {
				transform: rotate(0);
				visibility: visible;
				opacity: 1;
			}

			.messageIcon {
				visibility: hidden;
				transition-delay: 0ms;
			}

			.hoverInfo {
				display: none;
			}
		}
	}
}
</style>
